import React from "react";
import { Downloads } from "./Downloads";
import { DataFeed } from "./DataFeed";

interface PricingProps {
	packageName: string;
	description: string;
	downloadsAvailable?: boolean;
	downloadsDescription: string;
	dataFeedNotAvailableDisclaimer?: string;
	list?: string[];
	subscribeLink: string;
	children: React.ReactNode;
}

export function Pricing({
	packageName,
	description,
	downloadsAvailable,
	downloadsDescription,
	dataFeedNotAvailableDisclaimer,
	list,
	subscribeLink,
	children,
}: PricingProps) {
	let options;

	if (list) {
		options = list.map((item, index) => <li key={index}>{item}</li>);
	}

	return (
		<section className="section--subscription section--dark">
			<div className="container">
				<header className="flex justify-space-between align-center">
					<h2 className="section-title">
						Pricing
						<br /> {packageName}
					</h2>
				</header>

				<section className="subscription grid justify-space-between">
					<div className="grid__col-lg-auto grid__col-12">
						<div className="subscription__pro">
							<div className="pro__content">
								<div className="pro__heading">
									<p className="h4">Online subscription</p>
								</div>
								<div className="pro__typography typography">
									<p>{description}</p>
									<ul className="ticks ticks--small">
										{options}
										<li>Comprehensive search filters</li>
										<li>
											Regular updates to ensure up-to-date
											insights
										</li>
									</ul>
								</div>
							</div>
							<div className="pro__content pro__price">
								<div className="price__contact">
									<a
										href={subscribeLink}
										className="subscribe-link btn btn--primary"
									>
										Buy/Trial
									</a>
								</div>
							</div>
						</div>
						<Downloads
							available={downloadsAvailable}
							description={downloadsDescription}
						/>
					</div>

					<DataFeed
						notAvailableDisclaimer={dataFeedNotAvailableDisclaimer}
						packageName={packageName}
					/>
				</section>
			</div>
			{children}
		</section>
	);
}
